/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";

// External package
import { TypeAnimation } from "react-type-animation";
import { useSelector } from "react-redux";

import style from "./home.module.scss";
import {
  imagesProfileData,
  imagesGalleryData,
  portofolioData,
} from "../../source/data";
import { RootState } from "../../store/authStore";

const Home = () => {
  const imagesProfile = imagesProfileData;
  const imagesGallery = imagesGalleryData;
  const isMobile = useSelector((state: RootState) => state.auth.isMobile);

  return (
    <div>
      <div className={`home `}>
        <div className={`header-content mb-5`}>
          <div className="row">
            <div className="col-md-12 d-flex">
              <h1
                className={`font-vietnam-600 text-uppercase ${
                  isMobile ? "font-size-50 w-100 mb-0" : "font-size-160"
                }`}
              >
                the life
              </h1>
              {!isMobile && (
                <img
                  data-aos="zoom-in"
                  data-aos-duration="1000"
                  data-aos-easing="linear"
                  src={imagesProfile}
                  className={`${style.images_profile} ms-auto`}
                  alt=""
                />
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div
                className={`${isMobile ? "row" : "d-flex justify-content-end"}`}
              >
                <h2
                  className={`font-vietnam-100-italic text-uppercase ${
                    isMobile ? "font-size-50 col-12 mb-0" : "font-size-100"
                  }`}
                >
                  Of Code
                </h2>
                <h2
                  className={`font-vietnam-600 text-uppercase ${
                    isMobile ? "font-size-50 col-12" : "font-size-100"
                  }`}
                >
                  &nbsp; anytime
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 d-flex align-items-center">
              <div className="me-auto">
                <p
                  className={`mb-0 pb-0 font-vietnam-700 text-uppercase font-white-7 ${
                    isMobile ? "font-size-14" : ""
                  }`}
                >
                  digital vision
                </p>
                <p
                  className={`mb-0 pb-0 font-vietnam-700 text-uppercase font-white-7 ${
                    isMobile ? "font-size-14" : ""
                  }`}
                >
                  to life changed
                </p>
              </div>
              <h2
                className={`font-vietnam-600-italic  text-uppercase ${
                  isMobile ? "font-size-30" : "font-size-160"
                }`}
              >
                - 2019
              </h2>
            </div>
          </div>
        </div>
        <div className={`gallery-content mb-5`}>
          <div className="row">
            {imagesGallery.map((image, index) => {
              let imgWidth = 150;
              let imgHeight = 200;

              if (index === 2) {
                imgWidth = 300;
                imgHeight = 500;
              } else if (index === 5 || index === 6) {
                imgWidth = 200;
                imgHeight = 200;
              }

              return (
                <div
                  data-aos="zoom-out"
                  data-aos-duration={index * 1000}
                  className={`${
                    isMobile
                      ? "col-sm-6"
                      : index === 2
                      ? "col-md-3"
                      : style.col_md_2_custom
                  } ${
                    !isMobile && (index === 3 || index === 4)
                      ? style.position_bottom
                      : ""
                  }`}
                  key={image.id}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    width={imgWidth}
                    height={imgHeight}
                    style={{ width: "100%" }}
                  />
                  <figcaption className="d-flex justify-content-between font-size-14 mt-1">
                    <span className="font-vietnam-200">0{index + 1}</span>
                    <span className="font-vietnam-500">
                      {image.description}
                    </span>
                  </figcaption>
                </div>
              );
            })}
          </div>
        </div>
        <div className={`motivation-content mb-5 ${isMobile ? "" : "pt-4"}`}>
          <div className="row">
            <div
              className={`col-md-12 ${
                isMobile ? "" : "d-flex align-items-start"
              }`}
            >
              <div className="me-auto">
                <p className="mb-0 pb-0 font-vietnam-700 text-uppercase font-white-7">
                  cherish your special day
                </p>
                <p className="mb-0 pb-0 font-vietnam-700 text-uppercase font-white-7">
                  with our stunning,
                </p>
              </div>
              <div className={`${isMobile ? "mt-3" : ""}`}>
                <TypeAnimation
                  sequence={["Programming", 1000, "is not", 2000, "just", 3000]}
                  wrapper="h2"
                  cursor={true}
                  repeat={Infinity}
                  className={`vietnam-200-italic text-uppercase `}
                />
                <h2
                  className={`font-vietnam-500 text-uppercase ${
                    isMobile ? "font-size-14" : "font-size-36"
                  }`}
                >
                  about writing code
                </h2>
                <h2
                  className={`font-vietnam-500 text-uppercase ${
                    isMobile ? "font-size-14" : "font-size-36"
                  }`}
                >
                  it’s about solving problems with{" "}
                </h2>
                <h2
                  className={`font-vietnam-500 text-uppercase ${
                    isMobile ? "font-size-14" : "font-size-36"
                  }`}
                >
                  creativity and passion.
                </h2>
                <h2
                  className={`font-vietnam-200-italic text-uppercase ${
                    isMobile ? "font-size-14" : "font-size-36"
                  }`}
                >
                  Don’t be afraid to fail
                </h2>{" "}
                <h2
                  className={`font-vietnam-200-italic text-uppercase ${
                    isMobile ? "font-size-14" : "font-size-36"
                  }`}
                >
                  to fail <span>-</span>{" "}
                  <span
                    className={`font-vietnam-500 font-white-9 text-uppercase ${
                      isMobile ? "font-size-14" : "font-size-36"
                    }`}
                  >
                    Unknown
                  </span>
                </h2>{" "}
              </div>
            </div>
          </div>
        </div>
        <div className={`service-content mb-5 ${isMobile ? "" : "pt-5"}`}>
          <div className="row mb-5">
            <div className="col-md-12 d-flex">
              <div>
                <h2 className="font-vietnam-500 font-size-20 text-uppercase">
                  We provide a number of creative services to
                </h2>
                <h2 className="font-vietnam-200-italic font-size-20 text-uppercase">
                  help you achieve success in
                </h2>
                <h2 className="font-vietnam-500 font-size-20 text-uppercase">
                  the digital world.
                </h2>
              </div>
              <div className="ms-auto mb-0 pb-0 font-vietnam-700 text-uppercase font-white-7">
                <p className="mb-0 pb-0">Provide services </p>
                <p className="mb-0 pb-0">
                  your{" "}
                  <span className="font-vietnam-300-italic font-white-6">
                    digital life
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="services font-size-36 px-4 border-top border-bottom py-3 d-flex justify-content-between align-items-center text-uppercase font-vietnam-500 fw-bold">
                <span>Front End</span>
                <div className="count-project">
                  <span className="font-vietnam-500 font-size-18 lh-1">
                    10+
                  </span>
                  <p className="font-vietnam-500-italic mb-0 pb-0 font-size-14">
                    Projects
                  </p>
                </div>
              </div>
              <div className="services font-size-36 px-4 border-top border-bottom py-3 d-flex justify-content-between align-items-center text-uppercase font-vietnam-500 fw-bold">
                <span>Back End</span>
                <div className="count-project">
                  <span className="font-vietnam-500 font-size-18 lh-1">
                    10+
                  </span>
                  <p className="font-vietnam-500-italic mb-0 pb-0 font-size-14">
                    Projects
                  </p>
                </div>
              </div>
              <div className="services font-size-36 px-4 border-top border-bottom py-3 d-flex justify-content-between align-items-center text-uppercase font-vietnam-500 fw-bold">
                <span>Full Stack</span>
                <div className="count-project">
                  <span className="font-vietnam-500 font-size-18 lh-1">
                    10+
                  </span>
                  <p className="font-vietnam-500-italic mb-0 pb-0 font-size-14">
                    Projects
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={"portofolio-content mb-5 pt-5"}>
          <div className="row">
            <div className="col-md-6">
              <div className="portofolio-content_text text-center mb-4">
                <p className="font-vietnam-500 font-size-28">{"</>"}</p>
                <p className="mb-0 pb-0 font-vietnam-500 font-size-28 text-capitalize lh-1">
                  let my portofolios
                </p>
                <p className="mb-0 pb-0 font-vietnam-500 font-size-28 text-capitalize">
                  capture
                </p>
              </div>
              <div className="text-center">
                <p className="mb-0 pb-0 font-vietnam-700 text-uppercase font-white-7">
                  cherish your special day
                </p>
                <p className="mb-0 pb-0 font-vietnam-700 text-uppercase font-white-7">
                  with our stunning,
                </p>
              </div>
              <div className="text-center mt-2">
                <a
                  href="#"
                  className="font-vietnam-700 text-uppercase font-white-6 see-more"
                >
                  see more
                </a>
              </div>
            </div>
            {portofolioData.map((item, index) => (
              <div
                key={item.id}
                data-aos="fade-up"
                data-aos-anchor-placement="top-center"
                data-aos-duration={"1" + index * 400}
                className={`col-md-3 mt-${index > 1 ? 3 : 0}`}
              >
                <div
                  className={`portofolio-content_picture ${
                    item.label ? "border rounded" : ""
                  }`}
                >
                  <img
                    src={item.src}
                    alt={item.alt}
                    style={{ width: "100%" }}
                  />
                </div>
                {item.label && (
                  <figcaption className="d-flex justify-content-between font-size-14 mt-1">
                    <span className="font-vietnam-200">{item.value}</span>
                    <span className="font-vietnam-500"> {item.label}</span>
                  </figcaption>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className={"tagline-content mb-5 pt-5"}>
          <h2 className="font-white-9 font-vietnam-600 text-uppercase">
            Transforming coffee{" "}
          </h2>
          <h2 className="font-vietnam-100-italic">into code, and </h2>
          <h2 className="font-black-1 font-vietnam-900 fw-bold">
            dreams into reality.
          </h2>
        </div>
      </div>
    </div>
  );
};

export default Home;
